var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseModal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14.0 14.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1184,0.3234 C12.5496,-0.1078 13.2468,-0.1078 13.6766,0.3234 C14.1078,0.7532 14.1078,1.4504 13.6766,1.8816 L8.5582,7 L13.6766,12.1184 C14.1078,12.5496 14.1078,13.2468 13.6766,13.6766 C13.4624,13.8922 13.1796,14 12.8982,14 C12.6154,14 12.334,13.8922 12.1184,13.6766 L7,8.5582 L1.8816,13.6766 C1.666,13.8922 1.3846,14 1.1018,14 C0.8204,14 0.539,13.8922 0.3234,13.6766 C-0.1078,13.2468 -0.1078,12.5496 0.3234,12.1184 L5.4418,7 L0.3234,1.8816 C-0.1078,1.4504 -0.1078,0.7532 0.3234,0.3234 C0.7532,-0.1078 1.4504,-0.1078 1.8816,0.3234 L7,5.4418 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "2.49800181e-15,0 14,0 14,14 2.49800181e-15,14 2.49800181e-15,0",
    stroke: "none",
    fill: "#FF7800"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseModal);
export default __webpack_public_path__ + "static/media/close_modal.315323d58cbbbc31bdbba20f4d81c624.svg";
export { ForwardRef as ReactComponent };